export default {
	methods: {
		handleMenuItemClick(id, action, contextData) {
			const item = this.menuItems.find(({ id: itemId }) => itemId === id);
			// call external handler for the action if any
			if (item?.handler) {
				item.handler(contextData);
			}

			// call global handler for all items, if any
			if (this.onItemSelected) {
				this.onItemSelected(item);
			}

			this.close();
		},
	},
};
